import {
	chipSemantico,
	corSeveridade,
	corTipoEvento,
} from "../../../utils/centralDeAlertas/cores";

// Base compartilhada pelos chips pequenos da timeline (filtro de tipo,
// tipo do evento e severidade) — só a cor semântica muda entre eles.
const chipPequeno = {
	height: "20px",
	fontSize: "0.7rem",
	border: "0.6px solid",
	borderRadius: "10px",
	"& .MuiChip-label": { px: "6px" },
	"& .MuiChip-icon": { fontSize: "12px", color: "inherit", ml: "5px" },
};

const styles = (theme) => ({
	// Linha do cabeçalho: título/legenda à esquerda, botão ⓘ à direita.
	linhaCabecalho: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		gap: 1,
	},
	container: {
		display: "flex",
		flexDirection: "column",
		gap: 1.5,
		width: "100%",
		height: "100%",
		borderRadius: "10px",
		p: "16px",
	},
	header: {
		display: "flex",
		flexDirection: "column",
	},
	caption: {
		color: theme.palette.text.secondary,
	},
	chipsFiltro: {
		display: "flex",
		flexDirection: "row",
		flexWrap: "wrap",
		gap: 1,
	},
	// Chip togglável de tipo de evento: cheio (cor semântica) quando ativo,
	// outlined esmaecido quando inativo.
	chipFiltro: (tipo, ativo) => {
		if (ativo) {
			return {
				...chipPequeno,
				...chipSemantico(theme, corTipoEvento(theme, tipo)),
				fontWeight: 500,
			};
		}
		return {
			...chipPequeno,
			backgroundColor: "transparent",
			color: theme.palette.text.secondary,
			borderColor: theme.palette.divider,
			opacity: 0.6,
		};
	},
	// Preenche o espaço restante do Paper (altura fixa da linha vem da página,
	// itemAlturaFeeds) e rola por dentro.
	listaEventos: {
		position: "relative",
		flexGrow: 1,
		minHeight: 0,
		overflowY: "auto",
		pr: "4px",
	},
	cabecalhoDia: {
		position: "sticky",
		top: 0,
		zIndex: 1,
		bgcolor: theme.palette.background.paper,
		py: "6px",
		borderBottom: `1px solid ${theme.palette.divider}`,
	},
	textoCabecalhoDia: {
		color: theme.palette.text.secondary,
		fontWeight: 600,
	},
	// Separador sutil entre eventos do mesmo dia.
	divisorEventos: {
		borderColor: theme.palette.divider,
		mx: "6px",
	},
	linhaEvento: (clicavel) => ({
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		gap: 1,
		py: "8px",
		px: "6px",
		borderRadius: "8px",
		cursor: clicavel ? "pointer" : "default",
		...(clicavel && {
			"&:hover": {
				backgroundColor: theme.palette.action.hover,
			},
		}),
	}),
	iconeEvento: (tipo) => ({
		color: corTipoEvento(theme, tipo),
		fontSize: "18px",
		mt: "1px",
		flexShrink: 0,
	}),
	hora: {
		color: theme.palette.text.secondary,
		width: "38px",
		minWidth: "38px",
		mt: "2px",
	},
	conteudoEvento: {
		display: "flex",
		flexDirection: "column",
		gap: "2px",
		minWidth: 0,
		flexGrow: 1,
	},
	linhaChips: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		flexWrap: "wrap",
		gap: "6px",
	},
	chipTipoEvento: (tipo) => ({
		...chipPequeno,
		...chipSemantico(theme, corTipoEvento(theme, tipo)),
	}),
	chipSeveridade: (severidade) => ({
		...chipPequeno,
		...chipSemantico(theme, corSeveridade(theme, severidade)),
	}),
	textoOrigem: {
		color: theme.palette.text.secondary,
		minWidth: 0,
	},
	resumo: {
		color: theme.palette.text.primary,
		fontSize: "0.8rem",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	rodapePaginacao: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: 0.5,
		py: "10px",
	},
	textoPaginacao: {
		color: theme.palette.text.secondary,
	},
	botaoCarregarMais: {
		textTransform: "none",
	},
	estadoVazio: {
		flexGrow: 1,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		py: "48px",
	},
	skeletonChip: {
		borderRadius: "10px",
	},
	skeletonLinha: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		gap: 1,
		py: "8px",
	},
	skeletonTextos: {
		display: "flex",
		flexDirection: "column",
		gap: "4px",
		flexGrow: 1,
	},
});

export default styles;
